module.exports = __webpack_public_path__ + "static/img/davis_pictgrid34_980x833.88cbf11.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/davis_pictgrid34_980x833.jpg
// module id = LS1o
// module chunks = 0